import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductSuggestResponse } from '../models/ProductSuggestListModel'

export class GetProductSuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/productSuggestList',
      requesterInfo,
    })
  }

  public async getProductSuggest(): Promise<IProductSuggestResponse[]> {
    return await this.getAsync<IProductSuggestResponse[]>()
  }
}
